import { HourWiseGarmentsModel } from "./hour-wise-garments.model";
import { LineOperatorsModel } from "./line-operators.model";


export class PlannedActualRejGarmentsModel {
    unit: string;
    date: string;
    clientId: number;
    totalGarmentsPlanned: number;
    totalGarmentsCompleted: number;
    totalOperatorsLineWise: LineOperatorsModel[];
    hourWiseGarments: HourWiseGarmentsModel[];

    constructor(unit: string,
        date: string,
        clientId: number,
        totalGarmentsPlanned: number,
        totalGarmentsCompleted: number,
        totalOperatorsLineWise: LineOperatorsModel[],
        hourWiseGarments: HourWiseGarmentsModel[]) {
            this.unit = unit;
            this.date = date;
            this.clientId = clientId;
            this.totalGarmentsPlanned = totalGarmentsPlanned;
            this.totalGarmentsCompleted = totalGarmentsCompleted;
            this.totalOperatorsLineWise = totalOperatorsLineWise;
            this.hourWiseGarments = hourWiseGarments;
    }
    
}

